/**
 * The root DOM element for any interactable elements.
 *
 * @type {Element}
 */
const $root = document.querySelector( '#colt-connect-address-field' );

/**
 * Interactable DOM elements for the component. Empty until setup.
 *
 * @type {*}
 */
let $elements = {};

/**
 * Create the element list used within the component.
 *
 * @return void
 */
function setupElements() {
	$elements.input        = $root.querySelector( '.colt-connect-address-field' );
	$elements.submit       = $root.querySelector( '.colt-connect-address-field__submit' );
	$elements.placeId      = $root.querySelector( '.colt-connect-address-field__place-id' );
	$elements.placeLat     = $root.querySelector( '.colt-connect-address-field__lat' );
	$elements.placeLng     = $root.querySelector( '.colt-connect-address-field__lng' );
	$elements.placeAddress = $root.querySelector( '.colt-connect-address-field__address' );
}


function getPlaceValues() {
	const values = {
		id:      false,
		lat:     false,
		lng:     false,
		address: false,
	};

	if ( $elements.placeId.value ) {
		values.id = $elements.placeId.value;
	}

	if ( $elements.placeLat.value ) {
		values.lat = $elements.placeLat.value;
	}

	if ( $elements.placeLng.value ) {
		values.lng = $elements.placeLng.value;
	}

	if ( $elements.placeAddress.value ) {
		values.address = $elements.placeAddress.value;
	}

	return values;
}

export function connectAddressField() {
	if ( ! $root ) {
		return;
	}

	setupElements();

	if (
		! $elements.input ||
		! $elements.submit ||
		! $elements.placeId ||
		! $elements.placeLat ||
		! $elements.placeLng ||
		! $elements.placeAddress
	) {
		return;
	}

	const autocomplete = new google.maps.places.Autocomplete(
		$elements.input,
		{
			types:  [ 'geocode', 'establishment' ],
			fields: [ 'place_id', 'formatted_address', 'address_components', 'geometry' ],
		}
	);

	autocomplete.addListener( 'place_changed', () => {
		const place = autocomplete.getPlace();
		
		if ( ! place || ! place.place_id || ! place.geometry ) {
			return;
		}
		
		$elements.placeId.value      = place.place_id;
		$elements.placeLat.value     = place.geometry.location.lat();
		$elements.placeLng.value     = place.geometry.location.lng();
		$elements.placeAddress.value = place.formatted_address;

		$elements.submit.disabled = false;
	} );

	$elements.submit.addEventListener(
		'click',
		( event ) => {
			event.preventDefault();

			const { id, lat, lng, address } = getPlaceValues();

			if ( ! id || ! lat || ! lng || ! address ) {
				return;
			}

			const url        = $root.getAttribute( 'action' );
			const parameters = new URLSearchParams( {
				id,
				lat,
				lng,
				address,
			} );

			window.dataLayer.push( {
				event: 'connect_address_submit',
				id,
				lat,
				lng,
				address,
				url,
			} );

			window.location.href = `${ url }?${ parameters.toString() }`;
		}
	);
}